import { getApiOrigin, getPusherCluster, getPusherKey } from "@maeiz/core";

export const pusherConfig = {
    key: getPusherKey(),
    cluster: getPusherCluster(),
    authEndpoint: `${getApiOrigin()}/broadcasting/auth`,
} as const;
